module.exports = __webpack_public_path__ + "static/logos-clients.ec329b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/logos-clients.png
// module id = 477
// module chunks = 35783957827783